import { render, staticRenderFns } from "./organizationData.vue?vue&type=template&id=5621ee47&scoped=true"
import script from "./organizationData.vue?vue&type=script&lang=js"
export * from "./organizationData.vue?vue&type=script&lang=js"
import style0 from "./organizationData.vue?vue&type=style&index=0&id=5621ee47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621ee47",
  null
  
)

export default component.exports